export function crmPopup() {
    function getCookie(name) {
      const matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
      ));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    }
  
    function setCookie(name, value, options = {}) {
      options = { path: '/', ...options };
      let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
      for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
          updatedCookie += "=" + optionValue;
        }
      }
      document.cookie = updatedCookie;
      // console.log("Cookie set:", name, getCookie(name));
    }
  
 
    if (!_farlo.storage.get("mastheadLightboxShown","session")) {
      setTimeout(function () {
        const lightboxForm = document.querySelector('.crm-lightbox[farlo-ui="crm"]');
        if (lightboxForm) {
          const crmId = lightboxForm.getAttribute('data-crm-id') || lightboxForm.id;
          console.log("Found CRM lightbox element with ID:", crmId);
          const toggleButton = document.querySelector(`.farlo-ui-crm__toggle[data-crm-button-for="${crmId}"]`);
          if (toggleButton) {
            console.log("Auto-opening lightbox for:", crmId);
            toggleButton.click();
          } else {
            console.log("No toggle button found; calling farloUiCrmSignup with CRM id:", crmId);
            if (typeof farloUiCrmSignup === "function") {
              farloUiCrmSignup(crmId);
            }
          }
        } else {
          console.warn("No CRM lightbox element found in the DOM.");
        }
        if (document.querySelector('.crm-lightbox') && document.querySelector('.crm-lightbox').scrollHeight) {
          document.documentElement.style.setProperty('--crm-lightbox-height', (document.querySelector('.farlo-ui-crm__form-container').scrollHeight + 20) )
        }
      }, 1000);
    } else {
      // console.log("Cookie 'mastheadLightboxShown' is set; not auto-opening the lightbox.");
    }
  
  }
  